export default "__VITE_ASSET__5d178f57__"